import { useAuth } from 'hooks/auth';
import { useBottomSheet } from 'hooks/bottomSheet';
import { useToast } from 'hooks/toast';
import React, { useCallback, useEffect } from 'react';

import robotIcon from '@assets/icons/robot.svg';

import {
  Container,
  Content,
  RobotText,
  RobotTitle,
  RobotSubtitle,
  RobotImage,
  RobotBtn,
  RobotBtnText
} from './styles';

const RobotPage: React.FC = () => {
  const { closeBottomSheet } = useBottomSheet();
  const { removeToast } = useToast();
  const { signOut } = useAuth();

  useEffect(() => {
    async function clearAllElements() {
      closeBottomSheet();
      removeToast();
      await signOut();
    }

    clearAllElements();
  }, []);

  const handleClickRedirectUrl = useCallback(() => {
    const itauRedirectUrl = process.env.EXPO_APP_ITAU_REDIRECT_URL;

    if (!itauRedirectUrl) {
      return;
    }

    window.location.href = itauRedirectUrl;
  }, []);

  return (
    <Container
      contentContainerStyle={{
        flexGrow: 1,
        justifyContent: 'center'
      }}
    >
      <Content>
        <RobotImage source={robotIcon} />
        <RobotText>Oh..tivemos um erro por aqui</RobotText>
        <RobotTitle>
          Isso pode ocorrer por alguma instabilidade ou problema de conexão
          temporária.
        </RobotTitle>
        <RobotSubtitle>
          Por favor aguarde alguns instantes e tente novamente
        </RobotSubtitle>
        <RobotBtn testID="robotButton" onPress={handleClickRedirectUrl}>
          <RobotBtnText>Tentar novamente</RobotBtnText>
        </RobotBtn>
      </Content>
    </Container>
  );
};

export default RobotPage;
